import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, Pipe ,Input} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { GetNewsForViewDto,MediaLibraryServiceProxy } from '@shared/service-proxies/service-proxies';
import { DateTime } from 'luxon';
import {  result } from 'lodash-es';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'news-list-item',
  templateUrl: './news-list-item.component.html',
  styleUrls: ['./news-list-item.component.scss'],
  animations: [appModuleAnimation()]
})
export class NewsListItemComponent extends AppComponentBase implements OnInit {

    @Input() newsitemView:GetNewsForViewDto
    ImageData;
  constructor(injector: Injector,
    private _mediaLibraryProxy: MediaLibraryServiceProxy,
    private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _sinit:DomSanitizer
   ) {
    super(injector);
   }

  ngOnInit() {
    if(this.newsitemView.news.newsImageId!=undefined){
    this._mediaLibraryProxy.getMedia(this.newsitemView.news.newsImageId).subscribe((mediaResult)=>{
        this.ImageData= this._sinit.bypassSecurityTrustResourceUrl( mediaResult.fileContent);
    });
    }else
    this.ImageData='/assets/common/images/carousel-01.png';
  }
  goToNews(newsId)
  {
    let navigationExtras: NavigationExtras = {
        queryParams: {
            "id": newsId,
            "loc":2
        }
    };
    this._router.navigate(['new-details'], navigationExtras);
  }

}
